export function slugify(value = "") {
  return String(value)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

export function isValidYear(year) {
  const current = new Date().getFullYear();
  return Number.isInteger(year) && year >= 1900 && year <= current + 5;
}

export function extractImdbId(show) {
  if (!show) return "";
  if (show.omdbData?.imdbId) return String(show.omdbData.imdbId).toLowerCase();
  const detailsMatch = show.detailsUrl?.match(/(tt\d{7,})/i)?.[1];
  return detailsMatch ? String(detailsMatch).toLowerCase() : "";
}

export function getCanonicalSlugCandidates(show) {
  if (!show) return [];

  const titleSlug = slugify(show.title || "show");
  const year =
    (isValidYear(show.year) ? show.year : null) ||
    (isValidYear(show.omdbData?.year) ? show.omdbData.year : null);
  const imdbId = extractImdbId(show);

  const candidates = [];
  if (titleSlug && year) candidates.push(`${titleSlug}-${year}`);
  if (titleSlug && show.id) candidates.push(`${titleSlug}-${show.id}`);
  if (titleSlug) candidates.push(titleSlug);
  if (imdbId) candidates.push(imdbId);

  return [...new Set(candidates.filter(Boolean))];
}

export function getCanonicalSlug(show) {
  if (!show) return "";
  if (show.slug) return String(show.slug);
  const [first] = getCanonicalSlugCandidates(show);
  return first || "";
}
